import {StyleSheet} from "aphrodite";
import * as React from "react";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {getPromptVariable} from "@khan/guide-core-helpers";
import type {
    ActionBubble as ActionBubbleType,
    RequestedInput as RequestedInputType,
} from "@khan/guide-types";

import {ActionBubbles} from "./action-bubbles.tsx";
import {RequestedInputs} from "./requested-input.tsx";

interface Props {
    isMostRecentMessage?: boolean;
    requestedInputs: ReadonlyArray<RequestedInputType>;
    actionBubbles: ReadonlyArray<ActionBubbleType>;
    interactionId?: string;
    onActionSelected: (action: ActionBubbleType) => void;
    dabIds?: readonly string[];
}

export const InputsAndActionBubbles = (props: Props): React.ReactElement => {
    const {
        isMostRecentMessage,
        requestedInputs,
        actionBubbles,
        interactionId,
        onActionSelected,
        dabIds,
    } = props;

    const [isAnyRequiredInputMissing, dispatch] = React.useReducer(
        (state, action) => {
            switch (action.type) {
                case "CHECK_REQUIRED_INPUTS":
                    return requestedInputs.some(
                        (i) =>
                            i.required &&
                            (getPromptVariable(i.variableName) || "").trim()
                                .length < 1,
                    );
                default:
                    return state;
            }
        },
        false,
    );

    React.useEffect(() => {
        dispatch({type: "CHECK_REQUIRED_INPUTS"});
    }, [requestedInputs]);

    return (
        <>
            {requestedInputs.length > 0 && (
                <RequestedInputs
                    inputs={requestedInputs}
                    disabled={!isMostRecentMessage}
                    onChange={() => dispatch({type: "CHECK_REQUIRED_INPUTS"})}
                />
            )}
            {actionBubbles.length > 0 && (
                <ActionBubbles
                    disabled={isAnyRequiredInputMissing}
                    isMostRecentMessage={isMostRecentMessage}
                    actionBubbles={actionBubbles}
                    style={styles.actionBubbles}
                    interactionId={interactionId}
                    onActionSelected={onActionSelected}
                    dabIds={dabIds}
                />
            )}
        </>
    );
};

const styles = StyleSheet.create({
    actionBubbles: {
        marginBlockStart: spacing.xSmall_8,
    },
});
